<template>
  <v-select :label="label" v-model="selectedLanguage" :items="languages" :dense="dense" outlined hide-details
    prepend-inner-icon="mdi-earth" no-data-text="Aucune langue proposée" @change="setLanguage">
    <template slot="selection" slot-scope="data">
      {{ getLanguageLabel(data.item) }}
    </template>
    <template slot="item" slot-scope="data">
      {{ getLanguageLabel(data.item) }}
    </template>
  </v-select>
</template>

<script>
import ConceptsStore from "../concepts-store";
import StoreConfiguration from "../store-configuration";
import { LANGUAGES_ENUM } from "../enums/languages";

export default {
  name: "LanguageSelector",

  props: {
    label: String,
    languages: Array,
    languageLabels: Object,
    dense: Boolean
  },

  data() {
    return {
      store: ConceptsStore.state,
      storeConfiguration: StoreConfiguration.state,
      selectedLanguage: '',
    }
  },

  async created() {
    await this.$router; // Wait for VueRouter to be set.

    // Case when no language has been defined in the URL :
    // Set the default language to 'fr' for the catalog ("not localized" option available).
    // Or to the first language available for the detail page of a concept.
    if (typeof this.$route.query.lang === 'undefined') {

      if (this.languages.includes("")) {
        this.selectedLanguage = "fr";
      } else {
        this.selectedLanguage = this.store.terminologyLanguages[0];
      }

      // passage de vide à valeur donc true
      this.setLanguage(true);
    } else {

      // The current lang exists in the list of available languages.
      if (this.languages.includes(this.$route.query.lang)) {
        this.selectedLanguage = this.$route.query.lang;
      } else {

        // Case of "indifferent" language option selected : if language exists, use it, otherwise use the first one.
        if (this.store.terminologyLanguages.includes(this.$route.query.lang)) {
          this.selectedLanguage = this.$route.query.lang;
        } else {

          // The language does not exist so take into account the first of the list.
          this.selectedLanguage = this.store.terminologyLanguages[0];
          this.setLanguage(false);
        }
      }
    }
  },

  methods: {
    /**
     * Get the label of the language abbreviation.
     */
    getLanguageLabel: function (langAbbr) {
      return (this.languageLabels ? this.languageLabels[langAbbr] : undefined) || LANGUAGES_ENUM[langAbbr] || langAbbr;
    },

    /**
     * Set the language as a query URL parameter.
     */
    setLanguage: function (changed = true) {
      ConceptsStore.updateUrlParameters({ lang: this.selectedLanguage });
      if (changed) {
        this.$emit("languageChanged", this.selectedLanguage);
      }
    },
  },
}
</script>
